<script>
    import Button from './Button.svelte';
    import Icon from './Icon.svelte';
    import { logEvent } from './utils/logs';

    let dialog;

    const handle_modal_show = () => {
        logEvent('donate:show');
        dialog.showModal();
    };

    const handle_modal_close = () => {
        logEvent('donate:close');
        dialog.close();
    };

</script>


<Button on:click={handle_modal_show} xxl primary><slot>Donate</slot></Button>

<dialog class="bg-white rounded-lg m-auto" bind:this={dialog}>
    <button class="absolute right-2" on:click={handle_modal_close}><Icon times/></button>
    
    <iframe id='kofiframe' src='https://ko-fi.com/critikid/?hidefeed=true&widget=true&embed=true&preview=true' style='border:none;width:100%;padding:4px;background:#f9f9f9;' height='600' title='critikid'></iframe>
</dialog>

<style>
    dialog::backdrop {
        background-color: rgba(0, 0, 0, 0.5);
    }
</style>